'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * [strTrim 去除所有空格]
 *
 * @param   {[String]}  str  [str 字符串]
 *
 * @return  {[String]}       [return 字符串]
 */
var strTrim = exports.strTrim = function strTrim(str) {
    return str.replace(/\s*/g, "");
};
/**
 * 全局替换某个字符为另一个字符
 * @param {String} str 字符
 * @param {String} s1 包含的字符
 * @param {String} s2 要替换的字符,选填
 */
var strReplace = exports.strReplace = function strReplace(str, s1, s2) {
    return str.replace(new RegExp(s1, 'g'), s2);
};
/**
 * [strSubText 截取字符串并加省略号]
 *
 * @param   {[type]}  str     [str 字符串]
 * @param   {[type]}  length  [length 指定超出长度]
 *
 * @return  {[type]}          [return xxxx....]
 */
var strSubText = exports.strSubText = function strSubText(str, length) {
    if (str.length === 0) {
        return '';
    }
    if (str.length > length) {
        return str.substr(0, length) + "...";
    } else {
        return str;
    }
};
exports.default = {
    strTrim: strTrim,
    strReplace: strReplace,
    strSubText: strSubText
};